import { __makeTemplateObject } from '../../../../_virtual/_tslib.js';
import styled from 'styled-components';
var BoxArrowContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  margin-bottom: -1px;\n  justify-content: ", ";\n  ", "\n"], ["\n  display: flex;\n  margin-bottom: -1px;\n  justify-content: ", ";\n  ", "\n"])), function (props) {
  return props.placement === 'right' ? 'flex-end' : 'flex-start';
}, function (props) {
  return props.placement && props.placement === 'right' ? "margin-right: ".concat(props.margin, "px") : "margin-left: ".concat(props.margin, "px");
});
var templateObject_1;
export { BoxArrowContainer };